import { UserClaim, UserIdentityClaim } from '@crimsontide/core/client/user-permissions/interfaces';
import DotNetObject = DotNet.DotNetObject;

export const UserPermissionService = (() => {
  let dotNetObj: DotNetObject;

  const setDotNetReference = (obj: DotNetObject): void => {
    dotNetObj = obj;
  };

  const ready = async (): Promise<void> => {
    return new Promise((resolve) => {
      const timer = setInterval(() => {
        if (dotNetObj) {
          clearTimeout(timer);
          resolve();
        }
      }, 10);
    });
  }

  const getUserClaims = async (): Promise<UserClaim[]> => {
    if (dotNetObj) {
      return await dotNetObj.invokeMethodAsync<UserClaim[]>('GetUserClaims', true);
    } else {
      throw 'AuthenticationService DotNet Object Reference has not yet been implemented';
    }
  }

  const getUserClaimValues = async (): Promise<UserIdentityClaim[]> => {
    if (dotNetObj) {
      return await dotNetObj.invokeMethodAsync<UserIdentityClaim[]>('GetUserClaimValues', true);
    } else {
      throw 'AuthenticationService DotNet Object Reference has not yet been implemented';
    }
  }

  return {
    ready,
    setDotNetReference,
    getUserClaims: getUserClaims,
    getUserClaimValues: getUserClaimValues,
  };
})();
